import styled from "styled-components/macro"

const Residences = ({ children }) => {
  return <ResidencesPageWr>{children}</ResidencesPageWr>
}

const ResidencesPageWr = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;

  background-color: #0a2620;

  .residencesCategory {
    position: absolute;
    left: 5%;
    bottom: 0;
    margin: 4rem 2rem;
    display: flex;
    border: 0.5px solid var(--primary);

    .buttons {
      background-color: transparent;
      color: var(--primary);
      padding: 0.75rem 4rem;
      border: 0.5px solid var(--primary);
    }

    .active {
      background-color: var(--primary);
      color: white;
    }
  }

  /* .canvas_view {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
  } */

  .residences-popup {
    .addToFavorites {
      position: absolute;
      top: 0;
      right: 0;
      margin: 2rem;
      color: var(--black);
      border-radius: 2rem;
      padding: 0.25rem 2rem;
      font-family: ThirdFont;
      background-color: white;

      & div {
        padding: 1rem;
        border-radius: 100%;
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    .backButton {
      top: 50%;
      transform: translateY(-50%);
      border-radius: 2rem;
      background-color: var(--black);
      border: 2px slid red;
    }
  }

  .imageOverlayToggle {
    position: absolute;
    bottom: 0;
    right: 4rem;
    margin: 2rem;
    background-color: var(--black);
    z-index: 2;
    border-radius: 100%;
  }
`

export default Residences
